import React from 'react';
import {Card, CardActions, CardHeader, CardText, CardTitle} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import './Orders.css';

export default class Orders extends React.Component {
  render() {
    return (
      <div className="orders">
        <h3>Orders</h3>
          {this.props.orders.map((order) => (
            <Card key={order.id}>
              <CardTitle title={order.customerName} subtitle={order.customerAddress}/>
              <CardHeader 
                title={order.orderType} subtitle={order.deliveryDate} />
              <CardText>{order.amount}</CardText>
              <CardActions>
                <RaisedButton primary={true} label="Complete" />
              </CardActions>
            </Card>
          ))}
      </div>
    );
  }
}

Orders.propTypes = {
  orders: React.PropTypes.array.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/merchant/Orders.js